// extracted by mini-css-extract-plugin
export default {"sortIcon":"TableHead_sortIcon__qAtX-","sortUpDown":"TableHead_sortUpDown__USe17","activeTableHead":"TableHead_activeTableHead__Apymy","hoverClass":"TableHead_hoverClass__u6-Vf"};